import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { useContext, useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import MapContext from '../MapContext';
import Icon from 'ol/style/Icon';
import Style from 'ol/style/Style';
import { Feature } from 'ol';
import { Point } from 'ol/geom';
import { fromLonLat, toLonLat } from 'ol/proj';
import { setPanoGotoCoordinate } from '../../../../features/panoSlice';

export default function LookLayer() {

  const map = useContext(MapContext)
  const [canvas, setCanvas] = useState<any>(null);
  const [layer, setLayer] = useState<any>(null);
  const [firstTimeEnter, setFirstTimeEnter] = useState<any>(false);
  const [feature, setFeature] = useState<any>(null);
  const showPano = useAppSelector(state => state.toolbarState.showPano)
  const show3d = useAppSelector(state => state.toolbarState.show3d)
  const panoCoordinate = useAppSelector(state => state.panoState.panoCoordinate)
  const viewAngle = useAppSelector(state => state.panoState.viewAngle)
  const viewFov = useAppSelector(state => state.panoState.viewFov)
  const dispatch = useAppDispatch();

  useEffect(() => {
    const canvas = document.createElement('canvas');
    canvas.width = 60;
    canvas.height = 60;
    setCanvas(canvas);
    const layer = new VectorLayer({
      source: new VectorSource(), zIndex: 2000, visible: showPano, style: new Style({
        image: new Icon(
          {
            img: canvas,
            rotateWithView: true,
            imgSize: [60, 60],
            rotation: 0,
            opacity: 0.5
          })
      })
    });
    map.addLayer(layer);
    setLayer(layer);
    const feature :any = new Feature();
    setFeature(feature)
    const point = new Point(fromLonLat(panoCoordinate));
    feature.setGeometry(point);
    layer.getSource()?.addFeature(feature);
    return () => {
      map.removeLayer(layer);
    }
  }, [])

  useEffect(() => {
    if (layer) {
      layer.setVisible(showPano && !show3d);
      createCanvasContent(viewFov);
    }

    if (showPano && firstTimeEnter) {
      const position = map.getView().getCenter();
      const translated = toLonLat(position!);
      dispatch(setPanoGotoCoordinate(translated));
    }
    if (showPano && !firstTimeEnter) {
      dispatch(setPanoGotoCoordinate([32.55952766405587, 39.97679792936009]));
      setFirstTimeEnter(true)

    }
    return () => setFirstTimeEnter(false)

  }, [showPano, show3d])

  useEffect(() => {
    if (feature) {
      const point = new Point(fromLonLat(panoCoordinate));
      feature.setGeometry(point);
    }

  }, [panoCoordinate])

  useEffect(() => {
    if (feature) {
      const radius = viewAngle * (Math.PI / 180);
      layer.getStyle().getImage().setRotation(radius);
      feature.notify();
    }

  }, [viewAngle])

  useEffect(() => {
    if (feature) {
      createCanvasContent(viewFov);
      feature.notify();
    }

  }, [viewFov])

  const createCanvasContent = (fov: number): void => {
    const degree = 15 + fov * 75;
    const startDegree = 270 - (degree / 2);
    const endDegree = startDegree + degree;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, 60, 60);
    ctx.beginPath();
    ctx.moveTo(30, 30);
    ctx.arc(30, 30, 30, startDegree * (Math.PI / 180), endDegree * (Math.PI / 180));
    ctx.closePath();
    ctx.fillStyle = '#ff0000';
    ctx.fill();
    feature.notify();
  }
  return (
    <></>
  )
}
